import { render, staticRenderFns } from "./CupCodeTable.vue?vue&type=template&id=2bffe596"
import script from "./CupCodeTable.vue?vue&type=script&lang=ts"
export * from "./CupCodeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports